export default {
  label: 'Envoyer à',
  counter: '{{current}} sur {{max}}',
  default_badge: 'Par défaut',
  remove: 'Supprimer {{email}}',
  add_back: 'Rajouter',
  empty: 'Ajoutez au moins un e-mail.',
  add_label: 'Ajouter un e-mail',
  placeholder: 'nom@exemple.com',
  add: 'Ajouter',
  hint: "Jusqu'à {{max}} e-mails. Chacun reçoit son propre e-mail.",
  hint_full: "C'est le maximum pour cette liste. Supprimez un e-mail pour en ajouter un autre.",
  errors: {
    full: 'Vous pouvez ajouter {{max}} e-mails au maximum.',
    invalid: 'Saisissez un e-mail du type nom@exemple.com.',
    duplicate: '{{email}} figure déjà dans la liste.',
  },
};
